
import { defineComponent, ref, onMounted } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { ElMessage } from "element-plus";

export default defineComponent({
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("排除盈亏目录", ["系统设置"]);
    });

    const store = useStore();
    const selectedCategories = ref<number[]>([]);
    const categories = ref<Array<{ id: number; name: string }>>([]);
    const saving = ref(false);

    // Load box categories
    store
      .dispatch(Actions.GET_BOX_CATEGORIES)
      .then(() => {
        categories.value = store.getters.currentBoxCategories;
      })
      .catch((e: unknown) => {
        console.error("Failed to load box categories:", e);
      });

    // Load current config
    store
      .dispatch(Actions.GET_SYSTEM_SETTING, "excluded_gain_category_ids")
      .then(() => {
        const setting = store.getters.currentSystemSetting;
        if (setting && setting.value) {
          try {
            selectedCategories.value = setting.value
              .split(",")
              .map((s: string) => s.trim())
              .filter((s: string) => s !== "")
              .map((s: string) => Number(s));
          } catch (e) {
            console.error("Failed to parse excluded_gain_category_ids:", e);
          }
        }
      })
      .catch((e: unknown) => {
        console.error(e);
      });

    const onSave = () => {
      saving.value = true;
      const params = {
        system_setting: {
          key: "excluded_gain_category_ids",
          title: "排除盈亏目录",
          value: selectedCategories.value.join(","),
        },
      };

      store
        .dispatch(Actions.UPDATE_SYSTEM_SETTING, params)
        .then(() => {
          ElMessage.success("保存成功");
        })
        .catch((e: unknown) => {
          console.error(e);
          ElMessage.error("保存失败");
        })
        .finally(() => {
          saving.value = false;
        });
    };

    return {
      selectedCategories,
      categories,
      saving,
      onSave,
    };
  },
});
